// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"472f4807","834":"11fb2b2c"}[chunkId] + ".chunk.js";
};